class InfoTooltip extends HTMLElement {
  connectedCallback() {
    this._trigger = this.querySelector(".info-tooltip__trigger");
    this._panel = this.querySelector(".info-tooltip__panel");
    this._triggerType = this.dataset.trigger;

    if (this._triggerType === "hover") {
      this._trigger.addEventListener("mouseenter", () => this._open());
      this._trigger.addEventListener("mouseleave", () => this._close());
    } else {
      this._trigger.addEventListener("click", (e) => {
        e.stopPropagation();
        this._panel.hidden ? this._open() : this._close();
        this._closeAllPanelsExcept(this._panel);
      });
      document.addEventListener("click", () => this._close());
    }
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") this._close();
    });
  }

  _closeAllPanelsExcept(targetPanel) {
    const panels = document.querySelectorAll(".info-tooltip__panel");
    panels.forEach((panel) => {
      if (panel !== targetPanel) {
        panel.hidden = true;
      }
    });
  }

  _open() {
    this._panel.hidden = false;
    this._trigger.setAttribute("aria-expanded", "true");
  }

  _close() {
    this._panel.hidden = true;
    this._trigger.setAttribute("aria-expanded", "false");
  }
}

customElements.define("info-tooltip", InfoTooltip);
